<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入库单
        </div>
        <div style="padding: 20px;">

            <div>
                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="showForm">物品添加</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                        :data="waresDrugInfo"
                        :height="th"
                        style="width: 100%">
                        <el-table-column prop="name" label="药品名称"></el-table-column>

                        <el-table-column prop="supplierDrugName" label="供应商"></el-table-column>

                        <el-table-column prop="waresTypeDrugName" label="药品类型"></el-table-column>

                        <el-table-column prop="count" label="入库数量"></el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click.native.prevent="editRow(scope.$index, waresDrugInfo)">修改数量</el-button>
                                <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index,waresDrugInfo)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="footer" style="display: flex;justify-content: center;padding-top: 15px ;">
                <el-button :loading="loading" type="primary" style="height: 45px;width: 135px;font-size: 16px;" @click="confirm()">提交</el-button>
            </div>
        </div>

        <SelectWaresDrug ref="mySelectWaresDrug" v-show="showModalSelectWaresDrug" v-on:closeSelectWaresDrug="closeSelectWaresDrug" v-on:getWaresDrug='getWaresDrug'></SelectWaresDrug>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,setTokenBykey,removeTokenBykey,getTokenBykey,getMenuButton} from "@/utils/auth";
    import SelectWaresDrug from "./SelectWaresDrug";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,
                disabledAdd:true,
                menuButtonList:null,
                showModalAdd:false,
                showModalEdit:false,
                showModalSelectWaresDrug:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                waresDrugInfo:[],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    remarks:"",
                    waresDrugArr:null
                },

            }
        },
        components:{
            SelectWaresDrug
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight-20;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="物品添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            editRow(index,rows){
                this.$prompt('请输入此药品入库数量', '商品数量', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:/^[1-9]\d*$/,
                    inputErrorMessage:'添加数量不能为零',
                    inputType:'number'
                }).then(({ value }) => {
                    rows[index].count=value
                    this.waresDrugInfo=rows
                    setTokenBykey(getStaffCode()+'waresDrugInfoAdd',this.waresDrugInfo)
                    this.getList()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            closeSelectWaresDrug:function(){
                this.showModalSelectWaresDrug = !this.showModalSelectWaresDrug;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
                setTokenBykey(getStaffCode()+'waresDrugInfoAdd',this.waresDrugInfo)
            },
            showForm(){
                var list=this.waresDrugInfo
                this.$refs.mySelectWaresDrug.init(list);
                this.closeSelectWaresDrug()
            },
            getWaresDrug(row){
                this.waresDrugInfo.push(row)
                setTokenBykey(getStaffCode()+'waresDrugInfoAdd',this.waresDrugInfo)
            },
            confirm(){
                if(this.waresDrugInfo.length>0){
                    this.$prompt('请输入入库备注', '备注', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputType:'textarea'
                    }).then(({ value }) => {
                        this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                        this.addForm.remarks=value;
                        this.addForm.waresDrugArr=this.waresDrugInfo;
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl+"StockinDrug/Add",
                            data: this.addForm
                        }).then(
                            (response) => {
                                this.loading = false;
                                if (response.data.error == 0) {
                                    removeTokenBykey(getStaffCode()+'waresDrugInfoAdd')
                                    this.getList()
                                }else if(response.data.error == 1){
                                    this.$message({type: 'info', message: response.data.message});
                                }
                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消输入'
                        });       
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择入库药品'
                    });
                }
            },
            getList(){
                var info=getTokenBykey(getStaffCode()+'waresDrugInfoAdd');
                if(info){
                    this.waresDrugInfo=JSON.parse(info)
                }else{
                    this.waresDrugInfo=[]
                }
            },
        }
    }
</script>

<style scoped>

</style>